export function FixIllegalChars(StringToFix:string, FileName:boolean=false){
    var FixedString:string="";
    //replace white space chars
    FixedString=StringToFix.trim().replace(/\s+/g,"_");
    FixedString=FixedString.replace("\\\"", "");
    FixedString=FixedString.replace("#", "_");
    FixedString=FixedString.replace("/", "_");
    FixedString=FixedString.replace("\\", "_");
    FixedString=FixedString.replace("~", "_");
    FixedString=FixedString.replace("!", "_");
    FixedString=FixedString.replace("@", "_");
    FixedString=FixedString.replace("$", "_");
    FixedString=FixedString.replace("%", "_");
    FixedString=FixedString.replace("^", "_");
    FixedString=FixedString.replace("*", "_");
    FixedString=FixedString.replace("+", "_");
    FixedString=FixedString.replace("=", "_");
    FixedString=FixedString.replace("`", "_");
    FixedString=FixedString.replace("{", "_");
    FixedString=FixedString.replace("}", "_");
    FixedString=FixedString.replace("|", "_");
    FixedString=FixedString.replace("[", "_");
    FixedString=FixedString.replace("]", "_");
    FixedString=FixedString.replace(",", "_");
    FixedString=FixedString.replace(";", "_");
    FixedString=FixedString.replace("<", "_");
    FixedString=FixedString.replace(">", "_");
    FixedString=FixedString.replace("?", "_");
    FixedString=FixedString.replace("\.", "_");
    if (FileName)
    {
        FixedString=FixedString.replace("'", "_");
    }
    return FixedString;
}

